"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var Switch_1 = __importDefault(require("./Switch"));
exports.Switch = Switch_1.default;
exports.default = Switch_1.default;
//# sourceMappingURL=index.js.map